module.exports = __WEBPACK_EXTERNAL_MODULE__1145__;


// WEBPACK FOOTER //
// webpack:///external umd "jQuery"